import { render, staticRenderFns } from "./InitiateFunding.vue?vue&type=template&id=2c520d87"
import script from "./InitiateFunding.vue?vue&type=script&lang=js"
export * from "./InitiateFunding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports